document.addEventListener('Searchanise.Loaded', function() {
  (function($) {

$(document).on('Searchanise.AutocompleteUpdated', function(event, input, container) {
  console.log(1);
    $('.snize-ac-results-column .snize-product').each(function() {
        var productData = $(this).attr('id');
       var matchedString = productData.match(/(\d*)/g).join('');
  let product_id = matchedString;
 if (!$('.areviews_product_item', '#snize-ac-product-' + product_id).length) {
          $( '#snize-ac-product-' + product_id + ' .snize-title').after('<div class="areviews_product_item areviews_stars' + product_id + '" data-product-id="' + product_id + '"></div>');
        }
      });
   if ($('.areviews_product_item').length > 0 && typeof show_infiniti_areviews === "function"){show_infiniti_areviews();} 

});

$(document).on('Searchanise.ResultsUpdated', function(event, container) {
    console.log(2);
  oldarray = [];
   $('.snize-search-results .snize-product').each(function() {
        var productData = $(this).attr('id');
     console.log(productData);
       var matchedString = productData.match(/(\d*)/g).join('');
  let product_id = matchedString;
     console.log($('.areviews_product_item', '#snize-product-' + product_id).length);
     console.log($('#snize-product-' + product_id +' .snize-title'));
if (!$('.areviews_product_item', '#snize-product-' + product_id).length) {
          $( '#snize-product-' + product_id +' .snize-title').after('<div class="areviews_product_item areviews_stars' + product_id + '" data-product-id="' + product_id + '"></div>');
        }
      });
  
   if ($('.areviews_product_item').length > 0 && typeof show_infiniti_areviews === "function"){show_infiniti_areviews();} 

});

    $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
       console.log(3);
});

  })(window.Searchanise.$);
});

 